module.exports = __webpack_public_path__ + "img/yinsi_img1.50d13945.jpg";